const appConstants = {
    "lockTimer": 120000, // 2 Minutes
    "reservedKeys": [
        'id',
        'status',
        'patent_number',
        'resource_analyst',
        'reviewer',
        'delivery_date',
        'submission_date',
        'qced_date'
    ],
    "hiddenFields": [
        'hyperlink',
        'actions'
    ]
};

export default appConstants;
